(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elite-rating"] && !Shopify.designMode) return;
  try {
    (function(){
  'use strict';
  var singleton='__eliteGoldRatingStars';
  if(window[singleton]){window[singleton].boot();return;}
  var states=[],nextId=0,svgNS='http://www.w3.org/2000/svg',smallScreen=window.matchMedia('(max-width:767px)');
  var intersection=window.IntersectionObserver?new IntersectionObserver(function(entries){
    entries.forEach(function(entry){var state=entry.target._eliteGoldStars;if(state){state.inView=entry.isIntersecting;play(state);}});
  },{threshold:0}):null;
  function elapsed(state){return state.elapsed+(state.running?performance.now()-state.since:0);}
  function play(state){
    var running=state.inView&&!document.hidden;
    if(running!==state.running){
      if(state.running)state.elapsed+=performance.now()-state.since;
      state.since=performance.now();state.running=running;
    }
    state.wrapper.style.setProperty('--elite-star-play',running?'running':'paused');
  }
  function phase(state,stars){
    var time=elapsed(state);
    stars.style.setProperty('--elite-star-phase',(-time/1000).toFixed(3)+'s');
  }
  function fit(state){
    var row=state.wrapper.closest('.elite-rating-heading-row');
    if(!row||!row.isConnected)return;
    if(row!==state.row){
      state.row=row;
      state.observer.disconnect();
      state.observer.observe(state.root,{childList:true,subtree:true});
      state.observer.observe(row,{childList:true});
      if(state.resizeObserver)state.resizeObserver.disconnect();
      if(window.ResizeObserver){
        if(!state.resizeObserver)state.resizeObserver=new ResizeObserver(function(){queueFit(state);});
        state.resizeObserver.observe(row);
      }
    }
    var available=row.clientWidth;
    if(!smallScreen.matches||available>420){row.style.removeProperty('--elite-rating-scale');return;}
    if(available<=0)return;
    var current=Number(getComputedStyle(row).getPropertyValue('--elite-rating-scale'))||1;
    var items=Array.from(row.children).filter(function(item){return getComputedStyle(item).display!=='none';});
    var width=items.reduce(function(total,item){return total+item.getBoundingClientRect().width/current;},0);
    var gap=parseFloat(getComputedStyle(row).columnGap)||0;
    width+=Math.max(0,items.length-1)*gap/current;
    if(width<=0)return;
    var scale=Math.min(1,Math.max(0,available-1)/width);
    scale=Math.floor(scale*10000)/10000;
    if(Math.abs(scale-current)>0.0001)row.style.setProperty('--elite-rating-scale',String(scale));
  }
  function queueFit(state){
    if(state.fitQueued)return;
    state.fitQueued=true;
    requestAnimationFrame(function(){state.fitQueued=false;if(state.wrapper.isConnected)fit(state);});
  }
  function uniqueIds(svg){
    var ids={};
    svg.querySelectorAll('[id]').forEach(function(node){
      var old=node.id,id='elite-animated-gold-'+(++nextId);ids[old]=id;node.id=id;
    });
    svg.querySelectorAll('*').forEach(function(node){
      Array.from(node.attributes).forEach(function(attribute){
        var value=attribute.value.replace(/url\(#([^)]+)\)/g,function(reference,id){return ids[id]?'url(#'+ids[id]+')':reference;});
        if(value.charAt(0)==='#'&&ids[value.slice(1)])value='#'+ids[value.slice(1)];
        if(value!==attribute.value)node.setAttribute(attribute.name,value);
      });
    });
  }
  function enrich(state){
    var link=state.root.querySelector('a.elite-review-summary[href="#elite-reviews"]');
    if(!link){if(state.hasReal){phase(state,state.fallback);state.hasReal=false;}return;}
    var stars=link.children[0],text=link.children[1];
    if(!stars||!text)return;
    var match=text.textContent.match(/^\s*(\d+(?:[.,]\d+)?)/);
    if(!match)return;
    var score=Number(match[1].replace(',','.'));
    if(!Number.isFinite(score)||score<0||score>5)return;
    if(stars.dataset.eliteGoldScore===String(score)){state.hasReal=true;return;}
    if(!stars.classList.contains('elite-animated-stars')){
      stars.classList.add('elite-animated-stars');stars.setAttribute('aria-hidden','true');
      var fragment=document.createDocumentFragment();
      Array.from(state.fallback.children).forEach(function(slot,index){
        var clone=slot.cloneNode(true),svg=clone.querySelector('svg'),gold=svg.querySelector('.elite-star-gold');
        uniqueIds(svg);
        var id='elite-animated-gold-clip-'+(++nextId),defs=document.createElementNS(svgNS,'defs');
        var clip=document.createElementNS(svgNS,'clipPath'),rect=document.createElementNS(svgNS,'rect');
        clip.id=id;clip.setAttribute('clipPathUnits','userSpaceOnUse');
        rect.setAttribute('x','0');rect.setAttribute('y','0');rect.setAttribute('height','100');
        rect.setAttribute('width',String(Math.max(0,Math.min(1,score-index))*100));
        rect.setAttribute('data-elite-gold-fill',String(index));clip.appendChild(rect);defs.appendChild(clip);
        svg.insertBefore(defs,svg.firstChild);gold.setAttribute('clip-path','url(#'+id+')');fragment.appendChild(clone);
      });
      phase(state,stars);stars.replaceChildren(fragment);
    }else{
      stars.querySelectorAll('[data-elite-gold-fill]').forEach(function(rect){
        rect.setAttribute('width',String(Math.max(0,Math.min(1,score-Number(rect.getAttribute('data-elite-gold-fill'))))*100));
      });
    }
    stars.dataset.eliteGoldScore=String(score);state.hasReal=true;
  }
  function boot(){
    states=states.filter(function(state){
      if(state.wrapper.isConnected)return true;
      state.observer.disconnect();if(state.resizeObserver)state.resizeObserver.disconnect();if(intersection)intersection.unobserve(state.wrapper);return false;
    });
    document.querySelectorAll('.elite-rating-widget').forEach(function(wrapper){
      if(wrapper._eliteGoldStars)return;
      var root=wrapper.querySelector('[data-elite-rating]'),fallback=wrapper.querySelector('.elite-rating-fallback');
      if(!root||!fallback)return;
      fallback.querySelectorAll('svg').forEach(uniqueIds);
      var box=wrapper.getBoundingClientRect();
      var state={wrapper:wrapper,root:root,fallback:fallback,elapsed:0,since:performance.now(),running:false,inView:!intersection||(box.bottom>0&&box.top<window.innerHeight&&box.right>0&&box.left<window.innerWidth),hasReal:false};
      state.row=wrapper.closest('.elite-rating-heading-row');
      wrapper._eliteGoldStars=state;states.push(state);play(state);
      state.observer=new MutationObserver(function(){enrich(state);queueFit(state);});
      state.observer.observe(root,{childList:true,subtree:true});
      if(state.row){
        state.observer.observe(state.row,{childList:true});
        if(window.ResizeObserver){state.resizeObserver=new ResizeObserver(function(){queueFit(state);});state.resizeObserver.observe(state.row);}
      }
      enrich(state);fit(state);
      if(intersection)intersection.observe(wrapper);
    });
  }
  window[singleton]={boot:boot};
  document.addEventListener('visibilitychange',function(){states.forEach(play);});
  document.addEventListener('shopify:section:load',boot);
  smallScreen.addEventListener('change',function(){states.forEach(queueFit);});
  if(!window.ResizeObserver)window.addEventListener('resize',function(){states.forEach(queueFit);});
  if(document.fonts)document.fonts.ready.then(function(){states.forEach(queueFit);});
  boot();
})();
  } catch(e) { console.error(e); }
})();

})();
